import LayoutSafeArea from '@components/layout/layout-safe-area/layout-safe-area';
import styles from './home-section.module.scss';
import cn from 'classnames';

export interface HomeSectionProps {
  title?: string;
  theme?: 'white' | 'dark' | 'blue';
}

const HomeSection: React.FC<React.PropsWithChildren<HomeSectionProps>> = ({
  title,
  children,
  theme = 'white',
}) => {
  return (
    <section
      className={cn(styles.section, {
        [styles.dark]: theme === 'dark',
        [styles.blue]: theme === 'blue',
      })}
    >
      <LayoutSafeArea>
        <h1 className={styles.title}>{title}</h1>
        <div className={styles.content}>{children}</div>
      </LayoutSafeArea>
    </section>
  );
};

export default HomeSection;
